const t = {
  name: "Education",
  dimensions: { width: 40, height: 34 },
  content: `
<svg version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
	 viewBox="0 0 40 34" style="enable-background:new 0 0 40 34;" xml:space="preserve">
<style type="text/css">
	.st0{fill: currentColor;}
</style>
<g>
	<g>
		<path class="st0" d="M20,0l20,11l0,0v11h-2v-9.9l-5,2.7V21c0,3.6-1.5,6.8-3.8,9.2C26.9,32.5,23.6,34,20,34c-7.2,0-13-5.8-13-13
			v-6.1L0,11L20,0z M20,22L9,16v5c0,6.1,4.9,11,11,11c3,0,5.8-1.2,7.8-3.2c2-2,3.2-4.7,3.2-7.8v-5L20,22z M20,2.3L4.2,11L20,19.7
			L35.9,11L20,2.3z"/>
	</g>
</g>
</svg>
  `
};
export {
  t as Education
};
